import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FaUserShield } from "react-icons/fa6";
import UiContext from "../store/ui-context";
import { login } from "../store/auth-slice";
import { useDispatch } from "react-redux";

const LoginDialog = (props) => {
  const dispatch = useDispatch();
  const passwordInputRef = useRef(null);
  const uiContext = useContext(UiContext);
  const { visible, onHide, onAuthorize } = props;

  const [loading, setLoading] = useState(false);
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");

  // use effect section
  useEffect(() => {
    if (visible) {
      setInputUsername("");
      setInputPassword("");
      //   setLoading(false);
    }
  }, [visible]);

  // api call section

  // other function section

  // handle ui event section

  const handleConfirm = async (event) => {
    setLoading(true);
    const username = inputUsername.trim();
    const password = inputPassword.trim();

    if (!username || username.length === 0) {
      uiContext.showErrorMsg("Error", "Username tidak boleh kosong");
      return;
    }

    if (!password || password.length === 0) {
      uiContext.showErrorMsg("Error", "Password tidak boleh kosong");
      return;
    }

    const response = await dispatch(
      login({ username: username, password: password })
    );

    if (response) {
      uiContext.showSuccessMsg("Success", "Login Success");
      onHide();
    } else {
      uiContext.showErrorMsg("Error", "Username atau password salah");
    }
    setLoading(false);
  };

  const handleOnKeyDownUsernameInput = (event) => {
    if (event.keyCode === 13) {
      passwordInputRef.current.focus();
    }
  };

  const handleOnKeyDownPasswordInput = (event) => {
    if (event.keyCode === 13) {
      handleConfirm();
    }
  };

  const dialogFooter = (
    <div className="row-between-center w-100 ">
      <Button
        className="w-100"
        label="Login"
        loading={loading}
        icon="pi pi-lock-open"
        onClick={handleConfirm}
      />
      <Button
        className="min-w-[2.8rem] flex-grow mr-0"
        loading={loading}
        icon="pi pi-arrow-left"
        outlined
        onClick={onHide}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "20rem" }}
      // breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={"Login"}
      closeOnEscape={false}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      closable={false}
      dismissableMask={true}
    >
      <div className="col-start-center w-100 relative h-100 gap-3 pt-2">
        <div className="col-center-center gap-5">
          <FaUserShield className="text-indigo-500" size={100} />
          <span className="text-indigo-500 font-bold text-xs">
            LOGIN UNTUK EDIT / TAMBAH MENU
          </span>
        </div>
        <div className="row-start-center p-inputgroup w-100">
          <i className="p-inputgroup-addon pi pi-user"></i>
          <InputText
            readOnly={loading}
            placeholder="Username"
            id="username"
            aria-describedby="username-help"
            onChange={(e) => setInputUsername(e.target.value)}
            autoFocus
            onKeyDown={handleOnKeyDownUsernameInput}
          />
        </div>

        <div className="row-start-center p-inputgroup w-100">
          <i className="p-inputgroup-addon pi pi-key"></i>
          <Password
            ref={passwordInputRef}
            readOnly={loading}
            value={inputPassword}
            feedback={false}
            placeholder="Password"
            id="password"
            onChange={(e) => setInputPassword(e.target.value)}
            onKeyDown={handleOnKeyDownPasswordInput}
          />
        </div>
      </div>
    </Dialog>
  );
};
export default LoginDialog;
